<script setup lang="ts">
import type { TestimonialModel } from '@su4r-frontend/api';

defineProps<TestimonialModel>();
</script>

<template>
    <section class="flex flex-col gap-2">
        <header class="flex flex-row">
            <div class="flex flex-1 flex-row items-center gap-2">
                <img
                    :src="personImage?.url + '?width=40&height=40&format=webp'"
                    class="aspect-square h-10 w-10 rounded-full object-cover"
                    :alt="personImage?.alt ?? ''"
                    width="40"
                    height="40"
                    loading="lazy" />

                <div class="flex flex-col">
                    <div v-if="personName" class="font-semibold">{{ personName }}</div>
                    <div v-if="personTitle">{{ personTitle }}</div>
                </div>
            </div>

            <div class="w-23">
                <img
                    :src="image?.url + '?width=92&format=webp'"
                    :alt="image?.alt ?? ''"
                    width="92"
                    class="object-cover" />
            </div>
        </header>
        <div v-if="text" class="content">
            <p>
                {{ text }}
            </p>
        </div>
    </section>
</template>
